import PauseCircleFilled from '@mui/icons-material/PauseCircleFilled';
import useStyles from './usePlayerButtonStyles.styles';

export type PauseButtonProps = {
  onClick: () => void;
};

const PauseButton = ({ onClick }: PauseButtonProps) => {
  const classes = useStyles();

  return (
    <button className={classes.button} onClick={onClick}>
      <PauseCircleFilled />
    </button>
  );
};

export default PauseButton;
